import { requestJson, type ApiEnvelope } from '@shared/api/http';

const DEVICE_ID_KEY = 'locs-device-id';

export type ImBootstrap = {
  userId: number;
  loginName: string;
  token: string;
  expiresAt: number;
};

export function getOrCreateSocketDeviceId() {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing) {
    return existing;
  }

  const deviceId =
    globalThis.crypto?.randomUUID?.() ??
    `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  localStorage.setItem(DEVICE_ID_KEY, deviceId);
  return deviceId;
}

export async function fetchImBootstrap(
  apiBase: string,
  clientVersion = '1.0',
): Promise<ImBootstrap> {
  const response = await requestJson<ApiEnvelope<ImBootstrap>>('/im/bootstrap', {
    baseUrl: apiBase,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      deviceId: getOrCreateSocketDeviceId(),
      clientType: 'web',
      runtimePlatform: 'web',
      implementation: 'web',
      clientVersion,
    }),
  });
  return response.data as ImBootstrap;
}
